/** Nederlandse valuta-formatter: 1234.56 → '€ 1.234,56' */
export function euro(value: number | null | undefined): string {
  if (value === null || value === undefined || isNaN(Number(value))) return '€ 0,00'
  return new Intl.NumberFormat('nl-NL', {
    style: 'currency',
    currency: 'EUR',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  })
    .format(Number(value))
    .replace(/ /g, ' ') // hard space → spatie
}

/** Heel getal in NL-notatie: 19405 → '19.405' */
export function nlGeheel(value: number | null | undefined): string {
  if (value === null || value === undefined || isNaN(Number(value))) return '-'
  return new Intl.NumberFormat('nl-NL', { maximumFractionDigits: 0 }).format(Math.round(Number(value)))
}

/** Decimaal getal in NL-notatie. */
export function nlGetal(value: number | null | undefined, decimalen = 2): string {
  if (value === null || value === undefined || isNaN(Number(value))) return '-'
  return new Intl.NumberFormat('nl-NL', {
    minimumFractionDigits: decimalen,
    maximumFractionDigits: decimalen,
  }).format(Number(value))
}

/** Datum DD/MM/YYYY. */
export function datumNL(value: string | Date | null | undefined): string {
  if (!value) return ''
  const d = typeof value === 'string' ? new Date(value) : value
  if (isNaN(d.getTime())) return ''
  return d.toLocaleDateString('nl-NL', { day: '2-digit', month: '2-digit', year: 'numeric' })
}
